import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HeaderVideoConverter extends CmsConverterService<HeaderVideoData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_header_image_normal_title_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    const altText = formData.st_header_image_normal_alternative_text?.value
    return {
      imageDesktop: CmsConverterService.mapImage(formData.st_header_image_normal_reference, lazyLoad, altText, title),
      imageMobile: CmsConverterService.mapImage(formData.st_header_image_mobile_reference, lazyLoad, altText, title),
      headline: formData.st_headline ?? defaultTextInput,
      videoId: formData.st_video ?? defaultTextInput,
      headlineEmpty: formData.st_headline_empty?.value ?? false,
    } as HeaderVideoData
  }
}

export const HEADER_VIDEO_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, HeaderVideoData>>('HeaderVideoConverterToken')

export interface HeaderVideoData extends ConvertedComponentData {
  imageDesktop: Image;
  imageMobile: Image;
  headline: TextInput;
  videoId: string;
  lazyLoad: boolean;
  headlineEmpty: boolean;
}
